import React, { useContext } from "react";
import { CartContext } from "../../context/cart.context";
import { Link } from "react-router-dom";
import { MinusIcon, PlusIcon } from "@heroicons/react/24/solid";

const ProductCard1 = ({ product }) => {
  const {
    addItemToCart,
    cartItems,
    removeItemToCart,
    // clearItemfromCart, // Not used in this component
    // cartCount, // Not used in this component
  } = useContext(CartContext);

  // Find the cart item for this product
  const cartItem = cartItems.find((item) => item.id === product.id);
  const quantity = cartItem ? cartItem.quantity : 0;

  const addProductToCart = () => {
    addItemToCart(product);
  };

  const removeProductToCart = () => {
    removeItemToCart(product);
  };

  return (
    <div
      className="w-72 border-[1px] border-cool-gray-300 font-poppins shadow-md rounded-xl
      duration-500 hover:scale-105 bg-primaryLight hover:shadow-xl hover:bg-primaryVeryLight"
    >
      <a href="#">
        <div className="bg-primaryVeryLight rounded-t-xl">
          <img
            src={product.imageSrc}
            alt={product.imageAlt}
            className="h-80 w-72 object-contain scale-[.85] rounded-t-xl"
          />
        </div>
        <div className="group px-4 py-3 w-72 h-44 bg-primaryLight rounded-b-xl  hover:bg-secondary text-cool-gray-500 hover:text-textWhite rounded-t-2xl duration-500 hover:shadow-xl">
          {/* ...discount/promo badge, description code unchanged... */}
          <div className="flex flex-row justify-between gap-2">
            <div>
              <div className="mt-2 max-w-[150px] ">
                <span className="text-cool-gray-500  text-xl font-poppins uppercase">
                  {product.description}
                </span>
                {/* Quantity control buttons, if instock = 0 then add link should be disabled  */}
                <br />
                {product.instock ? (
                  <span className="text-green-500"></span>
                ) : (
                  <span className="text-red-500 font-poppins text-C12 font-normal ">
                    Coming Soon...
                  </span>
                )}
              </div>
              <p className="text-C14 text-cool-gray-400 truncate ">&nbsp;</p>
              <div className="flex items-center"></div>
              <div className="flex items-center">
                <p className="text-xl font-poppins font-semibold  my-3">
                  {product.promoPrice === true
                    ? product.price
                    : (
                        parseFloat(product.actualprice) -
                        parseFloat(product.actualprice) *
                          (parseInt(product.discount) / 100)
                      ).toFixed(2) + " AED"}
                </p>
                {product.discount > 0 ? (
                  <del>
                    <p className="text-base font-poppins text-gray-600 ml-4">
                      {product.actualprice}
                    </p>
                  </del>
                ) : (
                  ""
                )}
              </div>
            </div>
            <div className="flex items-center">
              <div className="flex flex-col gap-2 justify-stretch p-1 items-center">
                <Link
                  onClick={(e) => {
                    if (!product.instock) {
                      e.preventDefault();
                      return;
                    }
                    addProductToCart();
                  }}
                  className={`flex w-10 h-[35px] border-[1px] border-secondary rounded-md
                        hover:bg-secondaryHover hover:text-textWhite group-hover:border-cool-gray-200 items-center
                        ${!product.instock ? "cursor-not-allowed" : ""}`}
                  aria-disabled={!product.instock}
                >
                  <PlusIcon className="mx-auto text-[12px] w-6 items-center justify-center text-center" />
                </Link>
                <div
                  className="w-10 h-[35px] border-secondary mx-auto items-center justify-center align-middle 
                   inline-flex border-[0px] rounded-md"
                >
                  <span className="text-2xl font-bold">{quantity}</span>
                </div>
                {quantity > 0 ? (
                  <Link
                    onClick={removeProductToCart}
                    className="flex w-10 h-[35px] border-[1px] border-secondary group-hover:border-cool-gray-200
                      rounded-md hover:bg-secondaryHover hover:text-textWhite items-center"
                  >
                    <MinusIcon className="mx-auto text-[12px] w-6  items-center justify-center text-center" />
                  </Link>
                ) : (
                  <span
                    className="flex w-10 h-[35px] border-[1px] border-secondary group-hover:border-cool-gray-200
                      rounded-md items-center opacity-50 cursor-not-allowed"
                  >
                    <MinusIcon className="mx-auto text-[12px] w-6  items-center justify-center text-center" />
                  </span>
                )}
              </div>
            </div>
          </div>
        </div>
      </a>
    </div>
  );
};

export default ProductCard1;
